
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signup/need",
      function () {
        return require("private-next-pages/auth/signup/need.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signup/need"])
      });
    }
  